// api.ts

const ip_used = "127.0.0.1"

const ENV = {
	dev: {
		apiUrl: `http://${ip_used}:8000/api/data`,
		socketUrl: `http://${ip_used}:8001`,  // Socket server on separate port
    },
    prod: {
		apiUrl: 'https://rb-internal-api-778778295326.us-central1.run.app/api/data',
		socketUrl: 'https://rb-internal-socket-778778295326.us-central1.run.app',  // Internal socket server
	},
	staging:{
		apiUrl: 'https://flask-app-staging-778778295326.us-central1.run.app/api/data',
		socketUrl: 'https://flask-socket-staging-778778295326.us-central1.run.app',  // Internal socket server
	}
};

// Auto-detect environment from URL at runtime
const getEnvironment = (): 'dev' | 'prod' | 'staging' => {
	const hostname = window.location.hostname;
	if (hostname === 'localhost' || hostname === '127.0.0.1') return 'dev';
	if (hostname.includes('staging')) return 'staging';
	return 'prod';
};

const currentEnv = getEnvironment();

export const config = {
	currentEnv,
	apiUrl: ENV[currentEnv].apiUrl,
	socketUrl: ENV[currentEnv].socketUrl,
};
